import React from 'react';
import { Link } from 'react-router-dom';
import './CareersSection.css';

const CareersSection: React.FC = () => {
  return (
    <section className="hc-section">
      <div className="hc-container">
        
        <div className="hc-left">
          <div className="hc-eyebrow">
            <span className="hc-dash"></span> CAREERS
          </div>
          <h2 className="hc-title">
            Build Your Career<br />
            With <span className="text-blue">Pick Pack Pro</span>
          </h2>
          <p className="hc-desc">
            At Pick Pack Pro, we are constantly growing and looking for passionate individuals to join our warehouse and logistics operations in Milton Keynes.
          </p>
          <p className="hc-desc">
            Whether you have years of experience in e-commerce fulfilment or are eager to start a new career in logistics, we provide a collaborative and rewarding environment where every team member plays a vital role.
          </p>
          <Link to="/careers" className="hc-btn">
            Join Our Team 
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
          </Link>
        </div>

        <div className="hc-right">
           <div className="hc-image-wrapper">
             {/* Decorative offset background lines behind the image */}
             <div className="hc-image-bg-blue"></div>
             <div className="hc-image-bg-orange"></div>
             
             <img 
               src="/Images/careers-team-new.jpg" 
               alt="Pick Pack Pro Warehouse Team" 
               className="hc-image" 
               loading="lazy" 
             />
           </div>
        </div>

      </div>
    </section>
  );
};

export default CareersSection;

